import { AutoComplete, AutoCompleteSelectEvent } from 'primereact/autocomplete';
import React, { useState } from 'react';
import { User } from '../../entities/User';
import { useAZUserSearch } from '../../services/AzService';
import SessionStorageService from '../../services/SessionStorageService';
import { TOKEN_TYPE } from '../../entities/Constants';
import { AzureUser } from 'src/entities/formTemplateDataType';

const AzureUsersLookUpComponent = (
    { userList, callback}: 
    {userList?: User[]; callback: (newList: User[])=>void;}
) => {

    const [search, setSearch] = useState<string>('');
    const token = SessionStorageService.getAccessToken(TOKEN_TYPE.GRAPH);
    const { users, error, loading } = useAZUserSearch(token, search);


    const mapAzureUserToUser= (azuser: AzureUser) => {
        const user = new User();
        user.email = azuser.mail;
        user.firstName = azuser.givenName;
        user.lastName = azuser.surname;
        user.phoneNumber = azuser.businessPhones?.[0] || azuser.mobilePhone;
        user.title = azuser.jobTitle;
        user.displayName = azuser.displayName;
        user.userName = azuser.userPrincipalName;
        return user;
    }

    const addUser = (e: AutoCompleteSelectEvent) => {
        if (!userList) userList = [];
        const selectedUser = users.find(user => user.mail === e.value.mail);
        if (userList.find(user => user.email == e.value.mail)) return;
        userList.push(mapAzureUserToUser(selectedUser));
        callback(userList);
        setSearch('');
    }

    return (
        <AutoComplete multiple forceSelection showEmptyMessage field="displayName"
            style={{width: '100%'}}
            value={userList}
            suggestions={users}
            completeMethod = {e => setSearch(e.query)}
            onChange={(e) => setSearch(e.value)}
            onSelect={addUser}
        />
    );
}

export default AzureUsersLookUpComponent;